export default "<ion-button (click)=\"dismiss()\">\n  <ion-icon slot=\"icon-only\" name=\"close\"></ion-icon>\n</ion-button>";